(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surf-saddle-cart-drawer"]) return;
  try {
    
(() => {
  const initializeCartDrawer = () => {
  const root = document.querySelector('[data-surf-saddle-cart-drawer]');
  if (!root || root.dataset.surfSaddleCartInitialized === 'true') return;

  root.dataset.surfSaddleCartInitialized = 'true';

  const dialog = root.querySelector('[data-surf-saddle-cart-dialog]');
  const addUrl = `${root.dataset.cartAddUrl}.js`;
  const changeUrl = `${root.dataset.cartChangeUrl}.js`;
  const sectionId = root.dataset.sectionId;
  const renderSelector = '[data-surf-saddle-cart-render]';
  const messageElement = root.querySelector('[data-surf-saddle-cart-message]');

  const showMessage = (message = '') => {
    messageElement.textContent = message;
    messageElement.hidden = !message;
  };

  const openDrawer = () => {
    if (!dialog.open) dialog.showModal();
    window.setTimeout(() => {
      const closeButton = root.querySelector('[data-surf-saddle-cart-close]');
      if (closeButton) closeButton.focus();
    }, 0);
  };

  const closeDrawer = () => {
    if (dialog.open) dialog.close();
  };

  const replaceDrawerContent = (html) => {
    if (!html) return false;
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const nextContent = documentFragment.querySelector(renderSelector);
    const currentContent = root.querySelector(renderSelector);
    if (!nextContent || !currentContent) return false;
    currentContent.innerHTML = nextContent.innerHTML;
    return true;
  };

  const requestDrawerSection = async () => {
    const separator = root.dataset.cartUrl.includes('?') ? '&' : '?';
    const response = await fetch(`${root.dataset.cartUrl}${separator}sections=${encodeURIComponent(sectionId)}`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh the cart.');
    const sections = await response.json();
    return sections[sectionId];
  };

  const refreshDrawer = async (sections) => {
    if (replaceDrawerContent(sections && sections[sectionId])) return;
    const html = await requestDrawerSection();
    if (!replaceDrawerContent(html)) throw new Error('Unable to refresh the cart.');
  };

  const setAddFormState = (form, busy) => {
    form.querySelectorAll('[type="submit"]').forEach((button) => {
      button.disabled = busy;
      const label = button.querySelector('[data-surf-saddle-add-label]');
      if (!label) return;
      if (!label.dataset.originalLabel) label.dataset.originalLabel = label.textContent;
      label.textContent = busy ? 'Adding…' : label.dataset.originalLabel;
    });
  };

  const cartSectionsData = () => ({
    sections: sectionId,
    sections_url: window.location.pathname
  });

  const addToCart = async (form) => {
    setAddFormState(form, true);
    showMessage();

    try {
      const formData = new FormData(form);
      Object.entries(cartSectionsData()).forEach(([key, value]) => formData.set(key, value));
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added to the cart.');
      await refreshDrawer(result.sections);
      openDrawer();
      document.dispatchEvent(new CustomEvent('surf-saddle:cart-updated', { detail: { cart: result } }));
    } catch (error) {
      showMessage(error.message || 'This item could not be added to the cart.');
    } finally {
      setAddFormState(form, false);
    }
  };

  const changeLine = async (key, quantity) => {
    showMessage();
    try {
      const response = await fetch(changeUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity,
          ...cartSectionsData()
        })
      });
      const result = await response.json();
      if (!response.ok) throw new Error('Unable to update the cart.');
      await refreshDrawer(result.sections);
      document.dispatchEvent(new CustomEvent('surf-saddle:cart-updated', { detail: { cart: result } }));
    } catch (error) {
      showMessage(error.message || 'Unable to update the cart.');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[data-surf-saddle-cart-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(form);
  }, true);

  root.addEventListener('click', (event) => {
    if (event.target === dialog || event.target.closest('[data-surf-saddle-cart-close]')) {
      closeDrawer();
      return;
    }

    const changeButton = event.target.closest('[data-surf-saddle-cart-change]');
    if (changeButton) changeLine(changeButton.dataset.key, Number(changeButton.dataset.quantity));
  });

  document.addEventListener('surf-saddle:open-cart', async () => {
    try {
      await refreshDrawer();
      openDrawer();
    } catch (error) {
      showMessage(error.message || 'Unable to load the cart.');
    }
  });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCartDrawer, { once: true });
  } else {
    initializeCartDrawer();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surf-saddle-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionSelector = '[data-ss-gallery]';

  const initializeGallery = (section) => {
    if (!section || section.dataset.ssGalleryInitialized === 'true') return;

    const carousel = section.querySelector('[data-ss-gallery-carousel]');
    if (!carousel) return;

    const previous = section.querySelector('[data-ss-gallery-previous]');
    const next = section.querySelector('[data-ss-gallery-next]');
    const amount = Math.max(carousel.clientWidth * 0.8, 280);
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    const scroll = (direction) => {
      carousel.scrollBy({ left: amount * direction, behavior });
    };

    if (previous) previous.addEventListener('click', () => scroll(-1));
    if (next) next.addEventListener('click', () => scroll(1));
    section.dataset.ssGalleryInitialized = 'true';
  };

  const initializeAllGalleries = (scope = document) => {
    if (scope.matches && scope.matches(sectionSelector)) initializeGallery(scope);
    scope.querySelectorAll(sectionSelector).forEach(initializeGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllGalleries(), { once: true });
  } else {
    initializeAllGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllGalleries(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
